import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import get from 'lodash.get';

import { noop } from 'ui-components/default-props/noop';
import { Button } from 'ui-components/components/button';
import { ButtonThemeService } from 'ui-components/services/button-theme-service';

import { FormattedMessagePropType } from '../../../../../../../prop-types/intl';
import { launchVoidModal } from '../../../../../../../store/labels/labels.actions';
import { FulfillmentPlanService } from '../../../../../../../services/fulfillment-plan-service';
import { ORDER_DETAILS_ACTIONS, useTrackOrderDetailsAction } from '../../../../event-tracking/use-track-order-details-action';
import style from '../style.module.less';

const VoidAction = ({
  fulfillments,
  selectedFulfillmentIds,
  hasExternalFulfillmentSelected = noop,
  hasMarkAsShippedSelected = noop,
  buttonText = null,
  buttonTheme = '',
  shouldReconcileShipTo = false,
}) => {
  const dispatch = useDispatch();
  const trackShipmentsVoidClick = useTrackOrderDetailsAction(ORDER_DETAILS_ACTIONS.SHIPMENTS_VOID);

  const openVoidModal = useCallback(() => {
    const mappedFulfillments = fulfillments
      .filter((fill) => {
        return selectedFulfillmentIds.includes(fill.fulfillmentId) && !FulfillmentPlanService.isExternal(fill) && !fill.isLabelVoided;
      })
      .map((fulfillment) => {
        return {
          fulfillmentId: fulfillment.fulfillmentId,
          serviceId: fulfillment.serviceId || get(fulfillment, 'returnConfiguration.serviceId'),
          carrierId: fulfillment.carrierId || get(fulfillment, 'returnConfiguration.carrierId'),
          trackingInformation: fulfillment.trackingInformation,
        };
      });
    dispatch(
      launchVoidModal({
        fulfillments: mappedFulfillments,
        shouldReconcileShipTo,
      }),
    );
    trackShipmentsVoidClick();
  }, [selectedFulfillmentIds, fulfillments, dispatch, trackShipmentsVoidClick, shouldReconcileShipTo]);

  const hasExternal = hasExternalFulfillmentSelected();
  const hasMarkAsShippedPlans = hasMarkAsShippedSelected();
  const isEnabled = selectedFulfillmentIds.length > 0 && !hasExternal && !hasMarkAsShippedPlans;
  return (
    <div>
      <Button className={style['shipment-action']} disabled={!isEnabled} onClick={openVoidModal} theme={buttonTheme}>
        {buttonText || <FormattedMessage defaultMessage='Void' description='orderDetails.void' id='MnVHZr' />}
      </Button>
    </div>
  );
};

VoidAction.propTypes = {
  fulfillments: PropTypes.array.isRequired,
  selectedFulfillmentIds: PropTypes.array.isRequired,
  hasExternalFulfillmentSelected: PropTypes.func,
  hasMarkAsShippedSelected: PropTypes.func,
  buttonText: PropTypes.oneOfType([PropTypes.string, FormattedMessagePropType]),
  buttonTheme: PropTypes.oneOf(ButtonThemeService.getButtonThemes()),
  shouldReconcileShipTo: PropTypes.bool,
};

export default VoidAction;
